import * as _ from 'lodash';

export function findDeep(obj: any, targetKey: string): any {
  // 1. Check if the current object has the key
  if (_.has(obj, targetKey)) {
    return _.get(obj, targetKey);
  }

  // 2. If it's an array or object, crawl deeper
  let found: any;

  _.forEach(obj, (value) => {
    if (_.isObject(value) || _.isArray(value)) {
      const result = findDeep(value, targetKey);
      if (!_.isUndefined(result)) {
        found = result;
        return false; // Lodash break: stops the loop early
      }
    }
  });

  return found;
}